(function ($, w, undefined) {
    var ComparisonList = {
        init: function () {
            this.objects = $('.j-widget-comparison-remove, .j-widget-comparison-add, .j-widget-comparison');

            this.data = [];

            var self = this;

            this.objects.each(function () {
                self.initProduct(this);
            });

        },

        initProduct: function (selector) {
            var me = $(selector);

            if (me.attr('id') == undefined) {
                return;
            }

            var product_id = me.attr('id').substr("comparison-product-" . length).split('-'),
                handler_id = product_id[1];
            product_id = product_id[0];

            var obj = {
                obj: me,
                product_id: product_id,
                handler_id: handler_id,
                skin: me.data('skin') || 'default',
                buttonSize: me.data('button-size') || null,
                showButtonText: me.data('show-button-text') || null,
            };
            this.data.push(obj);
            var self = this;
            var clicker = me.find('.j-button').length ? me.find('.j-button') : me;
            clicker.off('click.comparison').on('click.comparison', function () {
                if (me.is('.j-widget-comparison-remove')) {
                    self.removeProduct(handler_id, product_id);
                } else if (me.is('.j-widget-comparison-add')) {
                    self.addProduct(handler_id, product_id);
                } else {
                    return true;
                }

                return false;
            });
        },

        /**
         *
         * @param handler_id
         * @param id
         * @param callback
         */
        removeProduct: function (handler_id, id, callback) {
            if (this.trigger('onRemoveProduct', this.getProductsByHandlerAndProduct(handler_id, id), handler_id, id) === false) {
                return;
            }
            var data = this.serializeProductsByHandler(handler_id),
                href = GLOBAL.URI_PREFIX + '_widget/comparison/remove/' + id + '/';


            var self = this;
            sendAjax(href, data, function (status, response) {
                if (status === 'OK') {
                    for (var i = response.products.length; --i >= 0; ) {
                        var pr = response.products[i];

                        self.replaceProduct(pr);
                    }
                    self.count = response.count * 1;
                    self.trigger('onAfterRemoveProduct', self.getProductsByHandlerAndProduct(handler_id, id), handler_id, id);
                    self.trigger('onChange');
                    if (typeof callback === 'function') {
                        callback(status);
                    }
                }
            });
        },

        addProduct: function (handler_id, id) {
            if (this.trigger('onAddProduct', this.getProductsByHandlerAndProduct(handler_id, id), handler_id, id) === false) {
                return;
            }
            var data = this.serializeProductsByHandler(handler_id),
                href = GLOBAL.URI_PREFIX + '_widget/comparison/add/' + id + '/';

            var self = this;
            sendAjax(href, data, function (status, response) {
                if (status === 'OK') {
                    for (var i = response.products.length; --i >= 0; ) {
                        var pr = response.products[i];

                        self.replaceProduct(pr);
                    }
                    self.count = response.count * 1;
                    self.trigger('onAfterAddProduct', self.getProductsByHandlerAndProduct(handler_id, id), handler_id, id);
                    self.trigger('onChange');
                }
            });
        },

        clear: function (handler_id, callback) {
            if (this.trigger('onClear') === false) {
                return;
            }

            var href = GLOBAL.URI_PREFIX + '_widget/comparison/clear/' + (handler_id ? handler_id + '/' : ''),
                data = this.serializeProductsByHandler(handler_id);

            var self = this;
            sendAjax(href, data, function (status, response) {
                if (status === 'OK') {
                    for (var i = response.products.length; --i >= 0; ) {
                        var pr = response.products[i];

                        self.replaceProduct(pr);
                    }
                    self.count = response.count * 1;
                    self.trigger('onAfterClear');
                    self.trigger('onChange');
                    if (typeof callback === 'function') {
                        callback(status);
                    }
                }
            });
        },

        replaceProduct: function (productData) {
            var handler = productData.handler,
                id = productData.id,
                skin = productData.skin,
                buttonSize = productData.buttonSize,
                showButtonText = productData.showButtonText,
                html = productData.html;
            var product = null,
                index = -1;
            for (var i = this.data.length; --i >= 0; ) {
                var pr = this.data[i];
                if (
                    pr.handler_id == handler &&
                    pr.product_id == id &&
                    pr.skin == skin &&
                    pr.buttonSize == buttonSize &&
                    pr.showButtonText == showButtonText
                ) {
                    index = i;
                    product = pr;
                    break;
                }
            }


            if (product) {
                product.obj.removeAttr('id');
                var obj = $(html);
                obj.insertAfter(product.obj);
                product.obj.remove();

                this.data.splice(index, 1);

                this.initProduct(obj);
            }

        },

        getProductsByHandlerAndProduct: function (handler_id, product_id) {
            return $.grep(this.data, function (obj) {
                return obj.handler_id == handler_id && obj.product_id == product_id;
            });
        },

        getProductsByHandler: function (handler_id) {
            return $.grep(this.data, function (obj) {
                return obj.handler_id == handler_id;
            });
        },
        serializeProductsByHandler: function (handler_id) {
            var products = [];
            $.each(this.getProductsByHandler(handler_id), function (i, obj) {
                products.push({name: 'products[' + obj.product_id + '][skin]', value: obj.skin});
                if (obj.showButtonText !== null) {
                    products.push({name: 'products[' + obj.product_id + '][showButtonText]', value: obj.showButtonText});
                }
                if (obj.buttonSize !== null) {
                    products.push({name: 'products[' + obj.product_id + '][buttonSize]', value: obj.buttonSize});
                }
            });

            return products;
        }

    };
    $.extend(ComparisonList, TMEvents);
    $(function () {
        ComparisonList.init();
    });
    ComparisonList.count = 0;
    w.ComparisonList = ComparisonList;
})(jQuery, window);